/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_New_TabInputs */

const en_vc_onl_new_tab = /** @type {(inputs: Vc_Onl_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in a new tab`)
};

const zh_vc_onl_new_tab = /** @type {(inputs: Vc_Onl_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在新标签页打开`)
};

/**
* | output |
* | --- |
* | "Open in a new tab" |
*
* @param {Vc_Onl_New_TabInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_new_tab = /** @type {((inputs?: Vc_Onl_New_TabInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_New_TabInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_new_tab(inputs)
	return zh_vc_onl_new_tab(inputs)
});
export { vc_onl_new_tab as "vc.onl.new_tab" }